import { EditContext, usePickSaveContext, RecordContextProvider, Record, useEditController } from "ra-core";
import { EditProps } from "ra-core/esm/controller/details/useEditController";
import { FC } from "react";
import SaveContextProvider from "./SaveContextProvider";

const Edit: FC<EditProps> = ({ children, ...props }) => {
  const value = useEditController(props)
  return (
    <EditContext.Provider value={value}>
      <SaveContextProvider value={usePickSaveContext(value)}>
        <RecordContextProvider<Partial<Record>>
          value={value && value.record}
        >
          {children}
        </RecordContextProvider>
      </SaveContextProvider>
    </EditContext.Provider>
  )
}

export default Edit;
